

























import { Component, Vue } from "vue-property-decorator";
import CollectionEventPopup from "@/components/CollectionEvents/CollectionEventPopup.vue";
import MapFiltersContainer from "@/components/Map/MapFiltersContainer.vue";
import MapAddressSearch from "@/components/Map/MapAddressSearch.vue";
import LoadingPanel from "@/components/LoadingPanel.vue";
import mapStore from "@/store/mapStore";
import { Observer } from "mobx-vue";
import { reaction, toJS } from "mobx";
import { CollectionEventSummaryModel, CollectionIndexModel } from "@/api/CollectionEvents";
import CollectionEventSummary from "@/components/CollectionEvents/CollectionEventSummary.vue";
import TruckMarkers from "./TruckMarkers.vue";
import VideoRequestMarkers from "./VideoRequestMarkers.vue";
import userStore from "@/store/userStore";
import FormattedAddress from "@/components/Address/FormattedAddress.vue";
import { requestMarker } from "@/assets/icons/RequestMarkers";
import { getStatus, unsuccessfulTaskCount } from "@/api/Requests";
import RequestSummary from "@/components/Map/RequestSummary.vue";
import SelectedAddressSummary from "@/components/Map/SelectedAddressSummary.vue";
import TruckSummary from "@/components/Map/TruckSummary.vue";
import VideoRequestSummary from "@/components/Map/VideoRequestSummary.vue";
import { truckIcon } from "@/assets/icons/TruckIcons";
import { LatLngModel } from "@/api/Shared";
import { videoRequestMarker } from "@/assets/icons/VideoRequestMarkers";
import { VideoRequestStatusLabels } from "@/api/VideoRequest";
import { getCouncilBoundaryImage } from "@/api/Map/getCouncilBoundaryImage";

@Observer
@Component({
  components: {
    LoadingPanel,
    MapFiltersContainer,
    CollectionEventPopup,
    MapAddressSearch,
    TruckMarkers,
    VideoRequestMarkers,
    FormattedAddress,
    CollectionEventSummary,
    RequestSummary,
    SelectedAddressSummary,
    TruckSummary,
    VideoRequestSummary
  }
})
export default class MapNew extends Vue {
  minimumSearchResultZoomLevel = 17;

  mapStore = mapStore;
  userStore = userStore;
  dispose?: () => void;

  clusterSettings = {
    disableClusteringAtZoom: 16
  };

  defaultLayers: any = null;

  indexMarkers: { index: string; marker: any }[] = [];
  selectedAddressMarker: any;
  markerLayer: any;
  indexLayer: any;
  requestLayer: any;
  truckLayer: any;
  videoRequestLayer: any;
  councilBoundaryLayer: any;
  currentPointer: any = null;

  map: any;
  mapUI: any;
  popup: any = null;

  isSatelliteView = false;

  mounted() {
    this.closeAll();
    this.configureMapObject();

    const disposeRequestsChangedHandler = reaction(() => toJS(mapStore.requests), this.onRequestsChanged, { fireImmediately: true });
    const disposeRequestPopupOpenHandler = reaction(() => ({ isOpen: mapStore.isRequestPopupOpen, isSelected: mapStore.selectedRequest }), this.onRequestPopupOpen);
    const disposeRequestVisibilityHandler = reaction(() => mapStore.isRequestsVisible, this.onRequestsVisibilityChanged, { fireImmediately: true });

    const disposeNewCollectionEventsChangedHandler = reaction(() => [...mapStore.collectionEvents], this.onCollectionEventsChanged);
    const disposeCollectionIndexesChangedHandler = reaction(() => toJS(mapStore.collectionIndexes), this.onCollectionIndexesChanged);
    const disposeCollectionEventPopupOpenHandler = reaction(
      () => ({ isOpen: mapStore.isCollectionEventPopupOpen, isSelected: mapStore.selectedCollectionEvent }),
      this.onCollectionEventPopupOpen
    );

    const disposeUserSelectedAddressPointInfoHandler = reaction(() => mapStore.userSelectedAddressGeocode, this.onUserSelectedAddressChanged);
    const disposeSelectedAddressPopupOpenHandler = reaction(
      () => ({ isOpen: mapStore.isSelectedAddressPopupOpen, isSelected: mapStore.userSelectedAddressGeocode }),
      this.onSelectedAddressPopupOpen
    );

    const disposeTruckLocationChangedHandler = reaction(() => toJS(mapStore.truckLocations), this.onTruckLocationsChange);
    const disposeTruckSummaryPopupOpenHandler = reaction(() => ({ isOpen: mapStore.isTruckSummaryPopupOpen, isSelected: mapStore.selectedTruck }), this.onTruckSummaryPopupOpen);
    const disposeTruckVisibilityHandler = reaction(() => mapStore.isTrucksVisible, this.onTrucksVisibilityChanged, { fireImmediately: true });

    const disposeVideoRequestsChangedHandler = reaction(() => toJS(mapStore.videoRequests), this.onVideoRequestsChange);
    const disposeVideoRequestsPopupOpenHandler = reaction(
      () => ({ isOpen: mapStore.isVideoRequestsPopupOpen, isSelected: mapStore.selectedVideoRequest }),
      this.onVideoRequestPopupOpen
    );
    const disposeVideoRequestVisibilityHandler = reaction(() => mapStore.isVideoRequestsVisible, this.onVideoRequestsVisibilityChanged, { fireImmediately: true });

    const disposeWasteStreamConfigurationChangedHandler = reaction(() => toJS(mapStore.wasteConfiguration), this.onWasteConfigurationChanged);
    const disposeCouncilConfigurationChangedHandler = reaction(() => userStore.councilConfiguration, this.onCouncilIsSatelliteViewChanged, { fireImmediately: true });
    const disposeLayerChangedHandler = reaction(() => mapStore.isSatelliteView, this.onCouncilIsSatelliteViewChanged);

    const disposeWMSLayerChangedHandler = reaction(() => mapStore.isLgaLayerVisible, this.onCouncilBoundaryVisibilityChanged, { fireImmediately: true });

    const mapInitialCenterHandler = reaction(
      () => mapStore.initialCenter,
      () => {
        console.debug("mapStore.initialCenter changed:", mapStore.initialCenter.lat, mapStore.initialCenter.lng);
        this.map.getViewModel().setLookAtData(
          {
            position: { lat: mapStore.initialCenter.lat, lng: mapStore.initialCenter.lng },
            zoom: 12
          },
          false
        ); // true enables animation
      },
      { fireImmediately: false }
    );

    //for automation tests, add data-cy attribute to the map element
    this.$nextTick(() => {
      setTimeout(() => {
        this.addDataCyToMapElement();
      }, 500);
    });

    this.dispose = () => {
      disposeCollectionEventPopupOpenHandler();
      disposeRequestPopupOpenHandler();
      disposeTruckSummaryPopupOpenHandler();
      disposeTruckLocationChangedHandler();
      disposeSelectedAddressPopupOpenHandler();
      disposeRequestsChangedHandler();
      disposeRequestVisibilityHandler();
      disposeNewCollectionEventsChangedHandler();
      disposeCollectionIndexesChangedHandler();
      disposeWasteStreamConfigurationChangedHandler();
      disposeUserSelectedAddressPointInfoHandler();
      disposeCouncilConfigurationChangedHandler();
      disposeVideoRequestsChangedHandler();
      disposeVideoRequestsPopupOpenHandler();
      disposeLayerChangedHandler();
      disposeTruckVisibilityHandler();
      disposeVideoRequestVisibilityHandler();
      disposeWMSLayerChangedHandler();
      mapInitialCenterHandler();
    };

    if (this.mapStore.userSelectedAddress) {
      this.onUserSelectedAddressChanged();
    }
  }

  debounce<T extends (...args: any[]) => any>(func: T, wait = 300): (...args: Parameters<T>) => void {
    let timeout: number | undefined;

    return function(this: any, ...args: Parameters<T>): void {
      // Clear the previous timeout
      if (timeout !== undefined) {
        window.clearTimeout(timeout);
      }

      // Set a new timeout
      timeout = window.setTimeout(() => {
        func.apply(this, args);
        timeout = undefined;
      }, wait);
    };
  }

  configureMapObject() {
    const H = window.H;
    this.requestLayer = new H.map.Group();
    this.markerLayer = new H.map.Group();
    this.indexLayer = new H.map.Group();
    this.truckLayer = new H.map.Group();
    this.videoRequestLayer = new H.map.Group();
    this.councilBoundaryLayer = null;
    const platform = new H.service.Platform({
      apikey: process.env.VUE_APP_HERE_MAP_TILES_API_KEY
    });

    const engineType = H.Map.EngineType["HARP"];

    this.defaultLayers = platform.createDefaultLayers({
      engineType
    });

    const map = this.defaultLayers.vector.normal.map;
    map.setMin(mapStore.minZoom);
    map.setMax(mapStore.maxZoom);

    this.map = new H.Map(document.getElementById("map"), map, {
      engineType,
      center: { lat: mapStore.initialCenter.lat, lng: mapStore.initialCenter.lng },
      zoom: 12,
      pixelRatio: window.devicePixelRatio || 1,
      renderMode: "canvas",
      renderEngine: "HARP"
    });

    this.map.addObject(this.indexLayer);

    // Enable dynamic resizing of the map, based on the current size of the enclosing container
    window.addEventListener("resize", () => this.map.getViewPort().resize());

    // MapEvents enables the event system.
    // The behavior variable implements default interactions for pan/zoom (also on mobile touch environments).
    new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(this.map));

    // Add an event listener for bounds changes
    this.map.addEventListener("mapviewchangeend", () => {
      if (mapStore.bounds instanceof window.H.geo.Rect) {
        mapStore.previousBounds = mapStore.bounds as H.geo.Rect;
      } else {
        mapStore.previousBounds = undefined;
      }

      mapStore.bounds = this.map
        .getViewModel()
        .getLookAtData()
        .bounds.getBoundingBox(); // Get the current bounds
      console.debug("Map bounds updated:", mapStore.bounds);

      mapStore.zoom = this.map.getZoom();
      console.debug("Map zoom:", mapStore.zoom);

      if (!this.hasBoundsChangedSignificantly(mapStore.bounds)) {
        return;
      }

      this.debounce(async (zoom: number) => {
        this.clearMarkers(this.markerLayer);
        setTimeout(() => {
          this.fetchCollectionEvents(zoom);
          this.onCouncilBoundaryVisibilityChanged();
        }, 0);
      }, 300)(mapStore.zoom);
    });

    this.map.addEventListener("tap", (evt: any) => {
      if (evt.currentPointer.button === 0) {
        // Check if the tap event is on the map and not on a marker or other UI element
        if (!(evt.originalEvent.target instanceof HTMLImageElement)) {
          if (this.popup) {
            this.closeAll();
          }
        }
      }
    });

    //add  UI controls
    this.mapUI = window.H.ui.UI.createDefault(this.map, this.defaultLayers);

    //hide map settings
    const mapSettingsControl = this.mapUI.getControl("mapsettings");
    mapSettingsControl.setVisibility(false);

    //chenge postion of zoom control
    const zoom = this.mapUI.getControl("zoom");
    zoom.setAlignment("bottom-left");

    //hide the ScaleBar
    const scalebar = this.mapUI.getControl("scalebar");
    scalebar.setVisibility(false);

    return this.map;
  }

  hasBoundsChangedSignificantly(newBounds: any): boolean {
    // Calculate the difference in each bound

    if (mapStore.previousBounds) {
      const topDiff = Math.abs(newBounds.getTop() - mapStore.previousBounds.getTop());
      const bottomDiff = Math.abs(newBounds.getBottom() - mapStore.previousBounds.getBottom());
      const leftDiff = Math.abs(newBounds.getLeft() - mapStore.previousBounds.getLeft());
      const rightDiff = Math.abs(newBounds.getRight() - mapStore.previousBounds.getRight());

      const hasSignificantChange = topDiff > 0.001 || bottomDiff > 0.001 || leftDiff > 0.001 || rightDiff > 0.001;

      return hasSignificantChange;
    }

    return true; // If no previous bounds, consider it a significant change
  }

  closeAll() {
    mapStore.selectedCollectionEvent = null;
    mapStore.selectedRequest = null;
    mapStore.isSelectedAddressPopupOpen = false;
    mapStore.selectedTruck = null;
    mapStore.selectedVideoRequest = null;
  }

  addDataCyToMapElement() {
    const mapElement = document.getElementById("map");
    if (mapElement) {
      const firstChild = mapElement.firstElementChild;
      if (firstChild) {
        const firstChildOfFirstChild = firstChild.firstElementChild;
        if (firstChildOfFirstChild) {
          firstChildOfFirstChild.setAttribute("data-cy", "map");
        }
      }
    }
  }

  onCouncilBoundaryVisibilityChanged() {
    try {
      if (mapStore.isLgaLayerVisible) {
        if (!this.councilBoundaryLayer) {
          // Create proper group container
          this.councilBoundaryLayer = new window.H.map.Group();
        }

        // Update tiles for current view
        this.updateWmsTiles();

        // Only add if not already added
        if (!this.map.getObjects().includes(this.councilBoundaryLayer)) {
          this.map.addObject(this.councilBoundaryLayer);
        }
      } else {
        if (this.councilBoundaryLayer) {
          if (this.map.getObjects().includes(this.councilBoundaryLayer)) {
            this.map.removeObject(this.councilBoundaryLayer);
          }
        }
      }
    } catch (error) {
      console.error("Error toggling council boundary:", error);
    }
  }

  // Add this new method to handle WMS tiles
  async updateWmsTiles() {
    try {
      if (!this.councilBoundaryLayer) return;

      // Clear existing tiles
      this.councilBoundaryLayer.removeAll();

      // Only create tiles if layer is visible
      if (!mapStore.isLgaLayerVisible) return;

      // Get current map view properties
      const viewBounds = this.map.getViewModel().getLookAtData().bounds;

      // Calculate tile range for current view
      const bounds = viewBounds.getBoundingBox();

      const imageResponse = await getCouncilBoundaryImage({
        west: bounds.getLeft(),
        south: bounds.getBottom(),
        east: bounds.getRight(),
        north: bounds.getTop(),
        width: window.innerWidth,
        height: window.innerHeight
      });

      if (!imageResponse || !imageResponse.base64) {
        console.warn("No valid image data received for tile");
        return;
      }

      // Create a promise to handle image loading
      const loadImage = (dataUrl: string): Promise<HTMLImageElement> => {
        return new Promise((resolve, reject) => {
          const img = new Image();

          img.onload = () => resolve(img);
          img.onerror = e => {
            console.error("Failed to load image:", e);
            reject(new Error("Failed to load image from data URL"));
          };

          img.src = dataUrl;
        });
      };

      const dataUrl = `data:${imageResponse.type || "image/png"};base64,${imageResponse.base64}`;

      // Wait for the image to load
      const img = await loadImage(dataUrl);

      const overlay = new window.H.map.Overlay(new window.H.geo.Rect(imageResponse.rect[0], imageResponse.rect[1], imageResponse.rect[2], imageResponse.rect[3]), img, {
        volatility: true,
        zIndex: 99999999
      });

      // Add the overlay to the layer
      if (this.councilBoundaryLayer) {
        this.councilBoundaryLayer.addObject(overlay);
      } else {
        console.warn("Council boundary layer is not initialized");
      }
    } catch (error) {
      console.error("Error updating WMS tiles:", error);
    }
  }

  displayPopup(isOpen: boolean, position: LatLngModel | null, content: Vue | Element | Vue[] | Element[]) {
    if (isOpen && position) {
      if (this.popup) {
        this.popup.close();
        this.popup = null;
      }
      const H = window.H;

      this.popup = new H.ui.InfoBubble(
        { lat: position.latitude, lng: position.longitude },
        {
          content: (content as Vue).$el,
          showCloseButton: false
        }
      );

      this.mapUI.addBubble(this.popup);

      // Wait for multiple render cycles to ensure content is fully rendered
      this.$nextTick(() => {
        this.$nextTick(() => {
          const bubbleElement = this.popup.getElement();
          if (bubbleElement) {
            const bubbleBody = bubbleElement.querySelector(".H_ib_body");
            if (bubbleBody) {
              this.offsetBubbleTopLeft(this.currentPointer.viewportX, this.currentPointer.viewportY, bubbleBody.offsetWidth, bubbleBody.offsetHeight + 120);
            }
          }
        });
      });
    } else if (this.popup) {
      this.popup.close();
      this.popup = null;
    }
  }

  offsetBubbleTopLeft(left: number, top: number, widthAdjust: number, heightAdjust: number) {
    let xAdjust = 0;
    let yAdjust = 0;

    if (left < widthAdjust) {
      xAdjust = widthAdjust - left;
    }

    if (top < heightAdjust) {
      yAdjust = heightAdjust - top;
    }

    const mapCenterScreenCoords = this.map.geoToScreen(this.map.getCenter());
    // Apply offsets
    const shiftedMapCenterScreenCoords = {
      x: mapCenterScreenCoords.x - xAdjust,
      y: mapCenterScreenCoords.y - yAdjust
    };
    // Retrieves the geographical coordinates corresponding to the screen
    // coordinates
    const shiftedMapCenterGeoCoords = this.map.screenToGeo(shiftedMapCenterScreenCoords.x, shiftedMapCenterScreenCoords.y);
    // Set the new map center with animation
    this.map.setCenter(shiftedMapCenterGeoCoords, true);
  }

  onCouncilIsSatelliteViewChanged() {
    if (!this.isSatelliteView && !mapStore.isSatelliteView) {
      //do nothing, this is the initial load
    } else if (!this.isSatelliteView && mapStore.isSatelliteView) {
      this.map.setBaseLayer(this.defaultLayers.hybrid.liteday.raster);
      this.map.addLayer(this.defaultLayers.hybrid.liteday.vector);
    } else if (this.isSatelliteView && mapStore.isSatelliteView) {
      //do nothing, previous status is already in satellite view
    } else {
      this.map.removeLayer(this.defaultLayers.hybrid.liteday.vector);
      this.map.setBaseLayer(this.defaultLayers.vector.normal.map);
    }

    this.isSatelliteView = mapStore.isSatelliteView;
  }

  onRequestsChanged() {
    this.clearMarkers(this.requestLayer);

    if (mapStore.requests !== null) {
      const markers = mapStore.requests.map(item => {
        const requestIdentifier = (item.addressUnitNo ? item.addressUnitNo + "-" : "") + item.addressStreetNo + "-" + item.addressStreetName.replace(/ /g, "-");
        const status = getStatus(item);
        const svg = requestMarker(status, unsuccessfulTaskCount(item), requestIdentifier);

        const domElement = mapStore.createDomElementIconWithSvg(svg, status, "60");
        domElement.style.marginLeft = "-30px";
        domElement.querySelector("img")?.setAttribute("data-cy", "marker-request-" + status.toLowerCase().replace(/_/g, "-") + "-" + requestIdentifier);
        const marker = new window.H.map.DomMarker(
          {
            lat: item.latitude,
            lng: item.longitude
          },
          { icon: new window.H.map.DomIcon(domElement) }
        );

        marker.addEventListener("tap", (evt: any) => {
          if (evt.currentPointer.button === 0) {
            this.currentPointer = evt.currentPointer;
            mapStore.fetchRequestDetails(item);
            mapStore.isRequestPopupOpen = true;
          }
        });

        return marker;
      });

      this.requestLayer.addObjects(markers);
    }
  }

  onRequestPopupOpen() {
    this.displayPopup(mapStore.isRequestPopupOpen, mapStore.selectedRequest, this.$refs.requestSummary);

    this.updateTruckIconOpacity();
  }

  onRequestsVisibilityChanged() {
    if (mapStore.isRequestsVisible) {
      if (!this.map.getObjects().includes(this.requestLayer)) {
        this.map.addObject(this.requestLayer);
      }
    } else {
      if (this.map.getObjects().includes(this.requestLayer)) {
        this.map.removeObject(this.requestLayer);
      }
    }
  }

  onTrucksVisibilityChanged() {
    if (mapStore.isTrucksVisible) {
      if (!this.map.getObjects().includes(this.truckLayer)) {
        this.map.addObject(this.truckLayer);
      }
    } else {
      if (this.map.getObjects().includes(this.truckLayer)) {
        this.map.removeObject(this.truckLayer);
      }
    }
  }

  onVideoRequestsVisibilityChanged() {
    if (mapStore.isVideoRequestsVisible) {
      if (!this.map.getObjects().includes(this.videoRequestLayer)) {
        this.map.addObject(this.videoRequestLayer);
      }
    } else {
      if (this.map.getObjects().includes(this.videoRequestLayer)) {
        this.map.removeObject(this.videoRequestLayer);
      }
    }
  }

  getWasteStreamColor(wasteStreamId: number) {
    switch (wasteStreamId) {
      case 1:
        return "red";
      case 2:
        return "yellow";
      case 3:
        return "green";
      case 17:
        return "green";
      case 19:
        return "purple";
    }
  }

  onTruckLocationsChange() {
    this.clearMarkers(this.truckLayer);

    if (mapStore.truckLocations !== null) {
      const markers = mapStore.truckLocations.map(item => {
        const svg = truckIcon(item.wasteStreamId, item.truckCode);
        const domElement = mapStore.createDomElementIconWithSvg(svg, "truck-icon", "60");
        domElement.style.marginLeft = "-30px";
        domElement.querySelector("img")?.setAttribute("data-cy", "truck-" + item.truckCode);
        domElement.querySelector("img")?.classList.add("marker-truck-" + this.getWasteStreamColor(item.wasteStreamId));
        domElement.querySelector("img")?.classList.add("truck-locator");

        const marker = new window.H.map.DomMarker(
          {
            lat: item.latitude,
            lng: item.longitude
          },
          { icon: new window.H.map.DomIcon(domElement) }
        );

        marker.addEventListener("tap", (evt: any) => {
          if (evt.currentPointer.button === 0) {
            this.currentPointer = evt.currentPointer;
            mapStore.selectedTruck = item;
            mapStore.isTruckSummaryPopupOpen = true;
          }
        });

        return marker;
      });

      this.truckLayer.addObjects(markers);
    }
  }

  updateTruckIconOpacity() {
    const truckIcons = document.querySelectorAll("img.truck-locator");

    truckIcons.forEach((imgElement: Element) => {
      const img = imgElement as HTMLImageElement;

      // Get truck code from data-cy attribute
      const dataCy = img.getAttribute("data-cy");
      if (!dataCy) return;

      const truckCode = dataCy.replace("truck-", "");

      // Check if this truck should be dimmed
      const isDimmed = mapStore.selectedRequest && mapStore.selectedRequest.tasks.some(t => !!t.truckCode) && mapStore.selectedRequest.tasks.every(t => t.truckCode !== truckCode);

      if (mapStore.selectedRequest && isDimmed) {
        // Dim the truck icon
        img.classList.remove("truck-icon");
        img.classList.add("truck-icon-dimmed");
      } else {
        // Restore normal truck appearance
        img.classList.remove("truck-icon-dimmed");
        img.classList.add("truck-icon");
      }
    });
  }

  onVideoRequestsChange() {
    this.clearMarkers(this.videoRequestLayer);

    if (mapStore.videoRequests !== null) {
      const markers = mapStore.videoRequests.map(item => {
        const svg = videoRequestMarker(item);
        const domElement = mapStore.createDomElementIconWithSvg(svg, "video-request-icon", "60");
        domElement.style.marginLeft = "-30px";
        domElement.style.marginTop = "-50px";
        domElement.querySelector("img")?.setAttribute("data-cy", item.title.replace(/ /g, ""));
        domElement.querySelector("img")?.classList.add("video-request-" + VideoRequestStatusLabels[item.status] + "-marker");

        const marker = new window.H.map.DomMarker(
          {
            lat: item.latitude,
            lng: item.longitude
          },
          { icon: new window.H.map.DomIcon(domElement) }
        );

        marker.addEventListener("tap", (evt: any) => {
          if (evt.currentPointer.button === 0) {
            this.currentPointer = evt.currentPointer;
            mapStore.selectedVideoRequest = item;
            mapStore.isVideoRequestsPopupOpen = true;
          }
        });

        return marker;
      });

      // Add all video request markers at once
      this.videoRequestLayer.addObjects(markers);
    }
  }

  onTruckSummaryPopupOpen() {
    this.displayPopup(mapStore.isTruckSummaryPopupOpen, mapStore.selectedTruck, this.$refs.truckSummary);
  }

  onVideoRequestPopupOpen() {
    this.displayPopup(mapStore.isVideoRequestsPopupOpen, mapStore.selectedVideoRequest, this.$refs.videoRequestSummary);
  }

  onUserSelectedAddressChanged() {
    if (!this.mapStore.userSelectedAddressGeocode) {
      if (this.map.getObjects().includes(this.selectedAddressMarker)) {
        this.map.removeObject(this.selectedAddressMarker);
      }
      return;
    }

    const domElement = mapStore.createDomElementIcon(`${require("@/assets/icons/House Pin.svg")}`, "House Pin", "60");
    domElement.style.marginLeft = "-30px";
    domElement.querySelector("img")?.setAttribute("data-cy", "house-icon");

    this.selectedAddressMarker = new window.H.map.DomMarker(
      {
        lat: this.mapStore.userSelectedAddressGeocode.latitude,
        lng: this.mapStore.userSelectedAddressGeocode.longitude
      },
      { icon: new window.H.map.DomIcon(domElement) }
    );

    this.selectedAddressMarker.addEventListener("tap", (evt: any) => {
      if (evt.currentPointer.button === 0) {
        this.currentPointer = evt.currentPointer;
        this.closeAll();
        mapStore.isSelectedAddressPopupOpen = true;
      }
    });

    this.map.addObject(this.selectedAddressMarker);

    const zoomLevel = Math.max(this.minimumSearchResultZoomLevel, mapStore.zoom);
    this.map.getViewModel().setLookAtData(
      {
        position: { lat: this.mapStore.userSelectedAddressGeocode.latitude, lng: this.mapStore.userSelectedAddressGeocode.longitude },
        zoom: zoomLevel
      },
      3
    );
  }

  onSelectedAddressPopupOpen() {
    this.displayPopup(mapStore.isSelectedAddressPopupOpen, mapStore.userSelectedAddressGeocode, this.$refs.selectedAddressSummary);
  }

  onCollectionEventPopupOpen() {
    this.displayPopup(mapStore.isCollectionEventPopupOpen, mapStore.selectedCollectionEvent, this.$refs.summary);
  }

  createCollectionEventMarker(collectionEvent: CollectionEventSummaryModel): any {
    const icon = collectionEvent.isCollectionIssue
      ? mapStore.collectionIssueHereIcons[collectionEvent.wasteStreamId]
      : mapStore.collectionEventHereIcons[collectionEvent.wasteStreamId];

    icon.querySelector("img")?.setAttribute("data-cy", collectionEvent.wasteStreamId + "-" + collectionEvent.addressHash.replace(/ /g, ""));

    const collectionEventMarker = new window.H.map.DomMarker(
      {
        lat: collectionEvent.latitude,
        lng: collectionEvent.longitude
      },
      { icon: new window.H.map.DomIcon(icon) } // Use the custom DOM element as the icon
    );

    // Set the collection event ID as marker data
    collectionEventMarker.setData({
      id: collectionEvent.id
    });

    collectionEventMarker.addEventListener("tap", (evt: any) => {
      if (evt.currentPointer.button === 0) {
        this.currentPointer = evt.currentPointer;
        mapStore.selectedCollectionEvent = collectionEvent;
        mapStore.isCollectionEventPopupOpen = true;
      }
    });

    return collectionEventMarker;
  }

  clearMarkers(layer: any) {
    const markers = layer.getObjects();

    // Remove from layer immediately
    layer.removeAll();

    // Dispose markers in batches to avoid GC pressure
    const disposeInBatches = (markers: any[], batchSize = 50) => {
      if (markers.length === 0) return;

      const batch = markers.splice(0, batchSize);
      batch.forEach(marker => marker.dispose());

      if (markers.length > 0) {
        // Use setTimeout instead of requestAnimationFrame for GC breathing room
        setTimeout(() => disposeInBatches(markers, batchSize), 16);
      }
    };

    disposeInBatches([...markers]);
  }

  onCollectionEventsChanged() {
    const visibleEvents = this.mapStore.collectionEvents
      .filter(collectionEvent => mapStore.isEventVisible(collectionEvent))
      .map((collectionEvent: CollectionEventSummaryModel) => this.createCollectionEventMarker(collectionEvent));

    this.markerLayer.addObjects(visibleEvents);
  }

  onCollectionIndexesChanged() {
    this.clearMarkers(this.indexLayer);

    this.indexMarkers = [];
    const markers = mapStore.collectionIndexes
      .map(model => {
        const marker = this.createCollectionIndexMarker(model);
        if (marker) {
          this.indexMarkers.push({ index: model.index, marker });
        }
        return marker;
      })
      .filter(marker => marker !== null);

    // Add all collection index markers at once
    if (markers.length > 0) {
      this.indexLayer.addObjects(markers);
    }
  }

  createCollectionIndexMarker(model: CollectionIndexModel): any {
    const wasteStreamStats = model.wasteStreams.map(c => {
      let total = 0;

      const wasteConfig = mapStore.wasteConfiguration.find(w => w.id === c.wasteStreamId);
      if (!wasteConfig) return { id: c.wasteStreamId, total };

      if (wasteConfig.isCollectionsVisible) {
        total += c.collections;
      }

      if (wasteConfig.isIssuesVisible) {
        total += c.collectionIssues;
      }

      return { id: c.wasteStreamId, total };
    });

    const stats = wasteStreamStats.reduce((a, c) => {
      a[c.id] = c.total;
      return a;
    }, {} as Record<string, number>);

    const population = wasteStreamStats.reduce((a, c) => a + c.total, 0);

    if (population <= 0) {
      return null;
    }

    // Create a custom icon for the marker
    const element = this.createClusterIcon(stats, population);
    element.setAttribute("data-cy", "cluster-" + population);
    const icon = new window.H.map.DomIcon(element, { size: { w: 44, h: 44 } });

    // Create the marker
    const marker = new window.H.map.DomMarker(
      {
        lat: model.latitude,
        lng: model.longitude
      },
      { icon }
    );

    // Add a click event to zoom in on the cluster
    marker.addEventListener("tap", (evt: any) => {
      if (evt.currentPointer.button === 0) {
        this.map.getViewModel().setLookAtData(
          {
            position: { lat: model.latitude, lng: model.longitude },
            zoom: Math.min(mapStore.zoom + 3, 18)
          },
          3
        );
      }
    });

    return marker;
  }

  createClusterIcon(stats: Record<string, number>, population: number): HTMLElement {
    const container = document.createElement("div");
    container.className = "cluster-icon";
    container.style.position = "relative";
    container.style.width = "44px";
    container.style.height = "44px";
    container.style.display = "flex";
    container.style.alignItems = "center";
    container.style.justifyContent = "center";
    container.style.cursor = "pointer";

    // Create the base circle
    const baseCircle = document.createElement("div");
    baseCircle.style.position = "absolute";
    baseCircle.style.width = "100%";
    baseCircle.style.height = "100%";
    baseCircle.style.borderRadius = "50%";
    baseCircle.style.backgroundColor = "#ffffff";
    baseCircle.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.2)";
    container.appendChild(baseCircle);

    // Create segments using conic gradient
    const segments = document.createElement("div");
    segments.style.position = "absolute";
    segments.style.width = "100%";
    segments.style.height = "100%";
    segments.style.borderRadius = "50%";

    // Calculate the gradient stops
    let currentAngle = 0;
    const gradientStops = Object.entries(stats)
      .map(([key, value], index, array) => {
        const startAngle = currentAngle;
        const percentage = value / population;
        currentAngle += 360 * percentage;
        const color = mapStore.collectionEventColours[Number(key)] || `hsl(${(Number(key) * 40) % 360}, 70%, 50%)`;

        return Object.keys(stats).length === 1
          ? `${color} ${startAngle + 2}deg ${currentAngle}deg`
          : `${color} ${startAngle}deg ${currentAngle - 2}deg, #FFFFFF ${currentAngle - 2}deg ${currentAngle}deg`;
      })
      .join(", ");

    segments.style.background = `conic-gradient(${gradientStops})`;

    // Create a mask to show only the border
    const mask = document.createElement("div");
    mask.style.position = "absolute";
    mask.style.width = "calc(100% - 8px)";
    mask.style.height = "calc(100% - 8px)";
    mask.style.top = "4px";
    mask.style.left = "4px";
    mask.style.borderRadius = "50%";
    mask.style.backgroundColor = "white";

    segments.appendChild(mask);
    container.appendChild(segments);

    // Create the center circle with population
    const centerCircle = document.createElement("div");
    centerCircle.style.position = "absolute";
    centerCircle.style.width = "70%";
    centerCircle.style.height = "70%";
    centerCircle.style.borderRadius = "50%";
    centerCircle.style.backgroundColor = "white";
    centerCircle.style.display = "flex";
    centerCircle.style.alignItems = "center";
    centerCircle.style.justifyContent = "center";
    centerCircle.style.fontWeight = "bold";
    centerCircle.style.fontSize = "12px";
    centerCircle.textContent = population.toString();

    container.appendChild(centerCircle);

    return container;
  }

  async onWasteConfigurationChanged() {
    if (mapStore.zoom >= mapStore.minZoom && mapStore.zoom <= mapStore.maxZoom) {
      // Use requestAnimationFrame for non-blocking execution
      requestAnimationFrame(() => {
        if (mapStore.zoom >= this.clusterSettings.disableClusteringAtZoom) {
          this.clearMarkers(this.markerLayer);
          requestAnimationFrame(() => {
            this.onCollectionEventsChanged();
          });
        } else {
          this.clearMarkers(this.indexLayer);
          requestAnimationFrame(() => {
            this.onCollectionIndexesChanged();
          });
        }
      });
    }
  }

  async fetchCollectionEvents(zoom: number) {
    await this.fetchRelevantCollectionEvents();
  }

  async fetchRelevantCollectionEvents() {
    // Use requestAnimationFrame for non-blocking layer operations
    return new Promise<void>(resolve => {
      requestAnimationFrame(async () => {
        this.clearMarkers(this.indexLayer);

        if (mapStore.zoom >= mapStore.minZoom && mapStore.zoom <= mapStore.maxZoom) {
          if (mapStore.zoom >= this.clusterSettings.disableClusteringAtZoom) {
            console.debug("Fetching collection events");

            // Batch layer operations
            requestAnimationFrame(async () => {
              if (this.map.getObjects().includes(this.indexLayer)) {
                this.map.removeObject(this.indexLayer);
              }
              if (!this.map.getObjects().includes(this.markerLayer)) {
                this.map.addObject(this.markerLayer);
              }

              await mapStore.fetchCollectionEvents();
              resolve();
            });
          } else {
            console.debug("Fetching collection indexes");

            requestAnimationFrame(async () => {
              if (this.map.getObjects().includes(this.markerLayer)) {
                this.map.removeObject(this.markerLayer);
              }

              mapStore.previuosCollectionEvents = [];
              mapStore.collectionEvents = [];

              if (!this.map.getObjects().includes(this.indexLayer)) {
                this.map.addObject(this.indexLayer);
              }

              await mapStore.fetchCollectionIndexes();
              resolve();
            });
          }
        } else {
          resolve();
        }
      });
    });
  }

  destroyed() {
    if (this.dispose) this.dispose();
  }
}
